import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import 'rxjs/add/operator/map';
import * as moment from 'moment';
import { Specification } from '../model/Specification';

@Injectable()
export class LocationService {
  url:string = GLOBAL.url+"locations";

  constructor( private http:HttpClient ) {}
/**
 * Obtiene el listado de todas las ubicaciones.
 * Se le colocó limit 100 para que traiga hasta 100 ubicaciones(locaciones);
 * @return listado de ubicaciones o un error.
 */
  public get(){
    return this.http.get(this.url+`?limit=100` ).map( res => {
        return res;
    });
  }

  public getAll(){
    let url = this.url+'?limit=100';
    return this.http.get(url ).map( res => {
        return res;
    });
  }

  public emptyPositionsFromAllLocations(){
    let url = GLOBAL.url+'positions?name=S/P&limit=30';
    return this.http.get(url ).map( res => {
        return res;
    });
  }

  public positionsFromLocation(id:number){
    let url = GLOBAL.url+'positions?location_id='+id+'&limit=1000&sort=+name';
    return this.http.get(url ).map( res => {
        return res;
    });
  }

  public freePositionsFromLocation(id:number){
    let url = GLOBAL.url+'positions_not_busy?location='+id+'&limit=200&sort=+name';
    return this.http.get(url ).map( res => {
        return res;
    });
  }

/**
 * Envia un POST para almacenar información.
 * @param  prov información a enviar
 * @return      respuesta de la peticion http
 */
  public save(prov:any){
    return this.http.post(this.url, prov)
      .map( data => {
        return data;
      });
  }

/**
 * Actualiza un elemento en la base de datos
 * @param  url  url del elemento que se actualiza.
 * @param  body ¿?
 * @return      respuesta de la peticion http
 */
  public update(url:string, body){
    return this.http.put(url, body)
      .map( data => {return data;});
  }

/**
 * Elimina un registro de la base de datos
 * @param  url url del elemento que se elimina
 * @return     respuesta de la peticion http
 */
  public delete(url:string){
    return this.http.delete(url).map( response =>{
      return response;
    });

  }

/**
 * Transforma una fecha (YYYY-MM-DD 00:00:00) para ser almacenada en una BD.
 * @param  fechas fecha a transformar
 * @return        fecha con el formato (YYYY-MM-DD 00:00:00)
 */
 transformDates(fechas:Date):String{
   let fecha = moment(fechas);
   //2018-02-28 00:00:00
   return (fecha.year()+'-'+(fecha.month()+1)+'-'+fecha.date()+' 00:00:00');
 }

/**
 * Transforma un objeto a un formato JSON predefinido en el modelo.
 * @param  data Informacion a transformar.
 * @return      Objeto con el formato JSON correcto.
 */
  transformData(data:any){
    let p = new Specification(
      data['id'],
      data['codigo']
    );
    return p.getJson();
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/location.service.ts